<script setup lang="ts">
import { ProgressBar } from '@pkg/ui/components/ui/progressBar';
import { StarsRate } from '@pkg/ui/components/ui/stars-rate';

withDefaults(defineProps<{
  ratingTitle: string;
  ratingSubtitle?: string;
  ratingTotal?: number;
  ratingMaximum?: number;
  ratings?:
    {
      name?: string;
      value?: number | string;
    }[];
}>(), {
  ratingMaximum: 5,
  ratingTitle: '',
  ratingTotal: 0,
  ratingSubtitle: '',
  ratings: () => [{ name: '', value: 0 }],
});
</script>

<template>
  <div class="flex justify-between mb-16">
    <div>
      <h2 class="s-detail__rating__title">
        {{ ratingTitle }}
      </h2>
      <p class="s-detail__rating__subtitle">
        {{ ratingSubtitle }}
      </p>
    </div>
    <div v-if="ratingTotal" class="s-detail__rating__total">
      <p>{{ ratingTotal.toFixed(1) }}</p>
      <StarsRate :rating-total="ratingTotal" :rating-maximum="ratingMaximum" />
    </div>
  </div>
  <div v-for="rating in ratings" :key="rating.name" class="pb-16 flex items-end">
    <div class="flex-1 pr-16">
      <p class="pb-8">
        {{ rating.name }}
      </p>
      <ProgressBar
        v-if="ratingMaximum && rating.value !== undefined && rating.value !== null"
        :total-value="ratingMaximum"
        :progress-value="Number(rating.value)"
      />
    </div>
    <p class="s-detail__rating__title">
      {{ rating.value }}
    </p>
  </div>
</template>

<style scoped>
@import '~/assets/css/mixins/_mixins.index.pcss';

.s-detail__rating {
  &__title {
    @mixin h5-tenon;
    font-weight: bold;
  }

  &__subtitle {
    @mixin body-small;
    color: theme('colors.neutral.70');
  }

  &__total {
    @mixin h5-tenon;
    font-weight: bold;
    background-color: theme('colors.neutral.20');
    padding: 0px 8px ;
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
  }
}
</style>
